import { LogIn } from "lucide-react";

interface SessionExpiredBannerProps {
  /** Override the default "/login" href if the portal uses a different login route. */
  loginHref?: string;
}

/**
 * Inline banner shown when a staff member's portal token expires mid-session.
 * Rendered at the top of the page content — does NOT replace the full page so
 * the user can still see and interact with stale data while getting a new link.
 */
export function SessionExpiredBanner({ loginHref = "/login" }: SessionExpiredBannerProps) {
  return (
    <div
      data-testid="session-expired-banner"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        padding: "10px 16px",
        background: "rgba(234, 179, 8, 0.08)",
        border: "1px solid rgba(234, 179, 8, 0.25)",
        borderRadius: 10,
        marginBottom: 16,
        flexWrap: "wrap",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <LogIn size={15} color="#eab308" />
        <span
          style={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            fontSize: 13,
            color: "#eab308",
            fontWeight: 500,
          }}
        >
          Your session has expired — some data may be out of date.
        </span>
      </div>
      <a
        href={loginHref}
        data-testid="link-session-expired-login"
        style={{
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 12,
          fontWeight: 700,
          color: "#fff",
          background: "#7c3aed",
          borderRadius: 6,
          padding: "5px 12px",
          textDecoration: "none",
          whiteSpace: "nowrap",
        }}
      >
        Get a new link →
      </a>
    </div>
  );
}
